import { BaseService } from './base.service';
import { IBaseListingModel, BaseListingModel } from '../models/base-listing.model';
import { IApartmentParameter, IApartmentListingViewModel, IApartment, ApartmentDto } from '../models/apartment';
import { Uris } from '../common/constants';

export interface IApartmentService {
  initApartment(opts?: IApartment ): IApartment;
  recordApartment(appartment: IApartment ) : Promise<any>;
  updateApartment(apartmentId: number, blockId: number, apartment: IApartment ): Promise<any>;
  deleteApartment(apartmentId: number) : Promise<any>;
  getApartments(param: IApartmentParameter, allowPagination?: boolean): Promise<any>;
  getApartmentZones(apartmentId: string): Promise<any>;
  searchAptZones(param: any): Promise<any>;
  postApartmentZones(apartmentId: string, param: any): Promise<any>;
  patchApartmentZones(apartmentId: string, zoneId: string, param: any): Promise<any>;
  deleteApartmentZones(apartmentId: string, zoneId: string): Promise<any>;
  getBlockApartmentById(blockId: string, apartmentId: string);
  getBlockAppartments(blockId: string, param: IApartmentParameter, allowPagination?: boolean);
  createLocationNumber(blockId: string, apartmentId: string, oldLocationNumber: string, locationNumber: string);
}

export class ApartmentService extends BaseService implements IApartmentService {

  /**
   *
   */

  initApartment(opts: IApartment= {} ) : IApartment {
    return new ApartmentDto({
      ...opts
    })
  }

  compareApartment(oldApt, newApt) {
    let changes = {}

  }

  recordApartment(apartment: IApartment) : Promise<any> {
    return this.cookApartment(apartment)
        .then( cookedApartment =>{
          return super.post(Uris.Apartment,{ ...cookedApartment })
              .then( createdApartment => Promise.resolve(createdApartment))
              .catch( err => Promise.reject(err))
        })
  }

  updateApartment(apartmentId: number, blockId: number, apartment: IApartment) : Promise<any> {
    return this.cookApartment(apartment,'update')
        .then( cookedApartment =>{
          return super.patch(`${Uris.ApartmentId.replace(':id',apartmentId.toString())}`,{ ...cookedApartment })
              .then( updatedApartment => Promise.resolve(updatedApartment))
              .catch( error => Promise.reject(error))
        })
  }

  deleteApartment(apartmentId: number ) : Promise<any> {
     return super.delete(`${Uris.ApartmentId.replace(':id',apartmentId.toString())}`)
        .then( deletedApartment => Promise.resolve(deletedApartment) )
        .catch( error => Promise.reject(error) )
  }

  cookApartment(apartment: IApartment, task: string = 'create' ) : Promise<any> {

    const tenants= apartment.tenant.filter(item=> !!item)
    const owners= apartment.owner.filter(item => !!item)
    let cooked_apartment: any= {
      apartment_number: apartment.num_apartment.toString(),
      fk_apartment_block: apartment.block,
      floor: apartment.floor,
      type: apartment.type,
      ... apartment.surface && { square_meter: apartment.surface.toString() },
      relations: {
        tenants,
        owners
      },
      // apartment_as_block: apartment.apartment_as_block
    }
    if (apartment.apartment_as_block) {
      let apartmentAsBlock = Object.assign({}, {...apartment.apartment_as_block})
      cooked_apartment = {
        ...cooked_apartment,
        relations: {
          ...cooked_apartment.relations,
          maintenance_referents: apartmentAsBlock.maintenance_referents || [],
          vehicle_referents: apartmentAsBlock.vehicle_referents || []
        }
      }
      delete apartmentAsBlock.maintenance_referents
      delete apartmentAsBlock.vehicle_referents
      delete apartmentAsBlock.id
      delete apartmentAsBlock.updatedAt
      delete apartmentAsBlock.createdAt
      delete apartmentAsBlock.fk_address
      cooked_apartment = {
        ...cooked_apartment,
        apartment_as_block: apartmentAsBlock
      }
    }
    return Promise.resolve(cooked_apartment)
  }

  getApartments(param: IApartmentParameter, allowPagination?: boolean): Promise<any> {
    return super.get(Uris.Apartment, param)
      .then((response: IBaseListingModel<any>) => {
        if (allowPagination) {
          return Promise.resolve(new BaseListingModel<any>(response))
        }
        else return Promise.resolve(response.data);
      })
      .catch(error => console.log(error))
  }

  getApartmentZones(apartmentId: string): Promise<any> {
    return super.get(Uris.ApartmentZone.replace(':id', apartmentId))
      .then((response: any) => {
        return Promise.resolve(response.data)
      })
      .catch(error => console.log(error))
  }

  searchAptZones(param) {
    return super.get(Uris.ApartmentZoneSearch, param)
      .then((response: any) => {
        return Promise.resolve(response)
      })
      .catch(error => console.log(error))
  }

  postApartmentZones(apartmentId: string, param: any) {
    return super.post(Uris.ApartmentZone.replace(':id', apartmentId), param)
  }

  patchApartmentZones(apartmentId: string, zoneId: string, param: any) {
    return super.patch(Uris.ApartmentZoneById
      .replace(':id', apartmentId)
      .replace(':idz', zoneId)
      , param)
  }

  deleteApartmentZones(apartmentId: string, zoneId: string) {
    return super.delete(Uris.ApartmentZoneById
      .replace(':id', apartmentId)
      .replace(':idz', zoneId))
  }

  getBlockAppartments(blockId: string, param: IApartmentParameter, allowPagination?: boolean) {
    return super.get(Uris.BlockApartments.replace(':id', blockId), param)
      .then((response: IBaseListingModel<any>) => {
        if (allowPagination) {
          return Promise.resolve(new BaseListingModel<IApartmentListingViewModel>(response))
        }
        else return Promise.resolve(response);
      })
      .catch(error => console.log(error))
  }
  getBlockApartmentById(blockId: string, apartmentId: string) {
    return super.get(Uris.BlockApartmentId.replace(':id', blockId).replace(':cid', apartmentId))
      .then((response) => response)
      .catch(error => console.log(error))
  }
  createLocationNumber(blockId: string, apartmentId: string, oldLocationNumber: string, locationNumber: string) {
    return super.patch(Uris.BlockApartmentId.replace(':id', blockId).replace(':cid', apartmentId)
      , { location_number: locationNumber })
  }
}



// WEBPACK FOOTER //
// ./src/services/apartment.service.ts